export interface BibleBook {
  id: number;
  name: string;
  abbr: string;
  chapters: number;
  testament: "OT" | "NT";
}

export const BIBLE_BOOKS: BibleBook[] = [
  { id: 1, name: "Genesis", abbr: "Gen", chapters: 50, testament: "OT" },
  { id: 2, name: "Exodus", abbr: "Exod", chapters: 40, testament: "OT" },
  { id: 3, name: "Leviticus", abbr: "Lev", chapters: 27, testament: "OT" },
  { id: 4, name: "Numbers", abbr: "Num", chapters: 36, testament: "OT" },
  { id: 5, name: "Deuteronomy", abbr: "Deut", chapters: 34, testament: "OT" },
  { id: 6, name: "Joshua", abbr: "Josh", chapters: 24, testament: "OT" },
  { id: 7, name: "Judges", abbr: "Judg", chapters: 21, testament: "OT" },
  { id: 8, name: "Ruth", abbr: "Ruth", chapters: 4, testament: "OT" },
  { id: 9, name: "1 Samuel", abbr: "1Sam", chapters: 31, testament: "OT" },
  { id: 10, name: "2 Samuel", abbr: "2Sam", chapters: 24, testament: "OT" },
  { id: 11, name: "1 Kings", abbr: "1Kgs", chapters: 22, testament: "OT" },
  { id: 12, name: "2 Kings", abbr: "2Kgs", chapters: 25, testament: "OT" },
  { id: 13, name: "1 Chronicles", abbr: "1Chr", chapters: 29, testament: "OT" },
  { id: 14, name: "2 Chronicles", abbr: "2Chr", chapters: 36, testament: "OT" },
  { id: 15, name: "Ezra", abbr: "Ezra", chapters: 10, testament: "OT" },
  { id: 16, name: "Nehemiah", abbr: "Neh", chapters: 13, testament: "OT" },
  { id: 17, name: "Esther", abbr: "Esth", chapters: 10, testament: "OT" },
  { id: 18, name: "Job", abbr: "Job", chapters: 42, testament: "OT" },
  { id: 19, name: "Psalms", abbr: "Ps", chapters: 150, testament: "OT" },
  { id: 20, name: "Proverbs", abbr: "Prov", chapters: 31, testament: "OT" },
  { id: 21, name: "Ecclesiastes", abbr: "Eccl", chapters: 12, testament: "OT" },
  { id: 22, name: "Song of Solomon", abbr: "Song", chapters: 8, testament: "OT" },
  { id: 23, name: "Isaiah", abbr: "Isa", chapters: 66, testament: "OT" },
  { id: 24, name: "Jeremiah", abbr: "Jer", chapters: 52, testament: "OT" },
  { id: 25, name: "Lamentations", abbr: "Lam", chapters: 5, testament: "OT" },
  { id: 26, name: "Ezekiel", abbr: "Ezek", chapters: 48, testament: "OT" },
  { id: 27, name: "Daniel", abbr: "Dan", chapters: 12, testament: "OT" },
  { id: 28, name: "Hosea", abbr: "Hos", chapters: 14, testament: "OT" },
  { id: 29, name: "Joel", abbr: "Joel", chapters: 3, testament: "OT" },
  { id: 30, name: "Amos", abbr: "Amos", chapters: 9, testament: "OT" },
  { id: 31, name: "Obadiah", abbr: "Obad", chapters: 1, testament: "OT" },
  { id: 32, name: "Jonah", abbr: "Jonah", chapters: 4, testament: "OT" },
  { id: 33, name: "Micah", abbr: "Mic", chapters: 7, testament: "OT" },
  { id: 34, name: "Nahum", abbr: "Nah", chapters: 3, testament: "OT" },
  { id: 35, name: "Habakkuk", abbr: "Hab", chapters: 3, testament: "OT" },
  { id: 36, name: "Zephaniah", abbr: "Zeph", chapters: 3, testament: "OT" },
  { id: 37, name: "Haggai", abbr: "Hag", chapters: 2, testament: "OT" },
  { id: 38, name: "Zechariah", abbr: "Zech", chapters: 14, testament: "OT" },
  { id: 39, name: "Malachi", abbr: "Mal", chapters: 4, testament: "OT" },
  { id: 40, name: "Matthew", abbr: "Matt", chapters: 28, testament: "NT" },
  { id: 41, name: "Mark", abbr: "Mark", chapters: 16, testament: "NT" },
  { id: 42, name: "Luke", abbr: "Luke", chapters: 24, testament: "NT" },
  { id: 43, name: "John", abbr: "John", chapters: 21, testament: "NT" },
  { id: 44, name: "Acts", abbr: "Acts", chapters: 28, testament: "NT" },
  { id: 45, name: "Romans", abbr: "Rom", chapters: 16, testament: "NT" },
  { id: 46, name: "1 Corinthians", abbr: "1Cor", chapters: 16, testament: "NT" },
  { id: 47, name: "2 Corinthians", abbr: "2Cor", chapters: 13, testament: "NT" },
  { id: 48, name: "Galatians", abbr: "Gal", chapters: 6, testament: "NT" },
  { id: 49, name: "Ephesians", abbr: "Eph", chapters: 6, testament: "NT" },
  { id: 50, name: "Philippians", abbr: "Phil", chapters: 4, testament: "NT" },
  { id: 51, name: "Colossians", abbr: "Col", chapters: 4, testament: "NT" },
  { id: 52, name: "1 Thessalonians", abbr: "1Thess", chapters: 5, testament: "NT" },
  { id: 53, name: "2 Thessalonians", abbr: "2Thess", chapters: 3, testament: "NT" },
  { id: 54, name: "1 Timothy", abbr: "1Tim", chapters: 6, testament: "NT" },
  { id: 55, name: "2 Timothy", abbr: "2Tim", chapters: 4, testament: "NT" },
  { id: 56, name: "Titus", abbr: "Titus", chapters: 3, testament: "NT" },
  { id: 57, name: "Philemon", abbr: "Phlm", chapters: 1, testament: "NT" },
  { id: 58, name: "Hebrews", abbr: "Heb", chapters: 13, testament: "NT" },
  { id: 59, name: "James", abbr: "Jas", chapters: 5, testament: "NT" },
  { id: 60, name: "1 Peter", abbr: "1Pet", chapters: 5, testament: "NT" },
  { id: 61, name: "2 Peter", abbr: "2Pet", chapters: 3, testament: "NT" },
  { id: 62, name: "1 John", abbr: "1John", chapters: 5, testament: "NT" },
  { id: 63, name: "2 John", abbr: "2John", chapters: 1, testament: "NT" },
  { id: 64, name: "3 John", abbr: "3John", chapters: 1, testament: "NT" },
  { id: 65, name: "Jude", abbr: "Jude", chapters: 1, testament: "NT" },
  { id: 66, name: "Revelation", abbr: "Rev", chapters: 22, testament: "NT" },
];

export const OT_BOOKS = BIBLE_BOOKS.filter((b) => b.testament === "OT");
export const NT_BOOKS = BIBLE_BOOKS.filter((b) => b.testament === "NT");
